"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeUnicode = exports.encodeUnicode = exports.encodeAlternateNameValuesToBase64 = exports.decodeAlternateName = exports.decodeAlternateNameValuesToBase64 = void 0;
const base_64_1 = require("base-64");
const decodeAlternateNameValuesToBase64 = (altNames) => {
    const tempAlternateNames = [];
    altNames === null || altNames === void 0 ? void 0 : altNames.forEach(altName => {
        tempAlternateNames.push({
            locale: altName.locale,
            display: (0, exports.decodeUnicode)(altName.display || ''),
            kitchen: (0, exports.decodeUnicode)(altName.kitchen || ''),
            receipt: (0, exports.decodeUnicode)(altName.receipt || ''),
            description: (0, exports.decodeUnicode)(altName.description || ''),
        });
    });
    return tempAlternateNames;
};
exports.decodeAlternateNameValuesToBase64 = decodeAlternateNameValuesToBase64;
const decodeAlternateName = (altName) => {
    return {
        display: (0, exports.decodeUnicode)((altName === null || altName === void 0 ? void 0 : altName.display) || ''),
        kitchen: (0, exports.decodeUnicode)((altName === null || altName === void 0 ? void 0 : altName.kitchen) || ''),
        receipt: (0, exports.decodeUnicode)((altName === null || altName === void 0 ? void 0 : altName.receipt) || ''),
        description: (0, exports.decodeUnicode)((altName === null || altName === void 0 ? void 0 : altName.description) || ''),
    };
};
exports.decodeAlternateName = decodeAlternateName;
const encodeAlternateNameValuesToBase64 = (altNames) => {
    const tempAlternateNames = [];
    altNames === null || altNames === void 0 ? void 0 : altNames.forEach(altName => {
        tempAlternateNames.push({
            locale: altName.locale,
            display: (0, exports.encodeUnicode)(altName.display || ''),
            kitchen: (0, exports.encodeUnicode)(altName.kitchen || ''),
            receipt: (0, exports.encodeUnicode)(altName.receipt || ''),
            description: (0, exports.encodeUnicode)(altName.description || ''),
        });
    });
    return tempAlternateNames;
};
exports.encodeAlternateNameValuesToBase64 = encodeAlternateNameValuesToBase64;
const encodeUnicode = (unicodeString) => {
    const codeUnits = new Uint16Array(unicodeString.length);
    for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = unicodeString.charCodeAt(i);
    }
    return (0, base_64_1.encode)(String.fromCharCode(...new Uint8Array(codeUnits.buffer)));
};
exports.encodeUnicode = encodeUnicode;
const decodeUnicode = (encodedString) => {
    try {
        const binary = (0, base_64_1.decode)(encodedString);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < bytes.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return String.fromCharCode(...new Uint16Array(bytes.buffer));
    }
    catch (e) {
        return encodedString;
    }
};
exports.decodeUnicode = decodeUnicode;
//# sourceMappingURL=AlternateNameUtils.js.map